module.exports = __webpack_public_path__ + "static/img/about_dnn_3.ec9a8a8f.png";